import { render, staticRenderFns } from "./FoodMenuData.vue?vue&type=template&id=0af2cf92&"
import script from "./FoodMenuData.vue?vue&type=script&lang=js&"
export * from "./FoodMenuData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports